import { useEffect } from 'react';
import { useSnackbar } from 'notistack';

let snackbarRef = null;

export function setSnackbarRef(ref) {
  snackbarRef = ref;
}

const DEFAULT_ERROR_TIMEOUT = 5000;
const DEFAULT_SUCCESS_TIMEOUT = 3000;

/**
 * Show a toast notification using notistack.
 * Only the message is displayed (title is ignored).
 * @param {Object} notification - {
 *    state?: 'default' | 'error' | 'success' | 'warning' | 'info', (state is case-insensitive and normalized to lowercase, default is 'default')
 *    message,
 *    dismissAfter?
 * }
 */
export function notify(notification) {
  if (!snackbarRef) return;
  const message = notification.message ?? '';
  const variant = notification.state?.toLowerCase();
  const autoHideDuration = notification.dismissAfter ?? (variant === 'error' ? DEFAULT_ERROR_TIMEOUT : DEFAULT_SUCCESS_TIMEOUT);
  snackbarRef.enqueueSnackbar(message, {
    variant,
    autoHideDuration,
  });
}

export const notifyFailure = (message, dismissAfter) => notify({
  state: 'error',
  message,
  dismissAfter: dismissAfter ?? DEFAULT_ERROR_TIMEOUT,
});

export const notifySuccess = (message, dismissAfter) => notify({
  state: 'success',
  message,
  dismissAfter: dismissAfter ?? DEFAULT_SUCCESS_TIMEOUT,
});

/**
 * Renders nothing; captures useSnackbar() and registers it so notify/notifySuccess/notifyFailure work outside React.
 * Must be rendered inside SnackbarProvider.
 */
export const SnackbarUtilsConfigurator = () => {
  const snackbar = useSnackbar();
  useEffect(() => {
    setSnackbarRef(snackbar);
    return () => setSnackbarRef(null);
  }, [snackbar]);
  return null;
};
